import React, { Suspense } from 'react'
import Loader from './loader/Loader';

type TranslationLoaderProps = {
  children: React.ReactNode;
}
const TranslationLoader: React.FC<TranslationLoaderProps> = ({ children }) => {
  return (
    <React.Fragment>
        <Suspense fallback={<Loader />}>
            {children}
        </Suspense>
    </React.Fragment>
  )
}

export default TranslationLoader